import contentSettings from '@site/content.settings'

export default ({ route, store }) => {
  const { enable, cookie } = contentSettings.utm || {}
  if (enable) {
    store.dispatch('utm/FETCH_DATA', { cookie, route })
  }
}
